import React from 'react'
import { Button, FormItem, ThemeVariants } from 'rds'
import CheckoutFormCardSection from './CheckoutFormCardSection'

const CheckoutFormDiscountCode = ({
    buttonLabel,
    discountCode,
    onChange,
    onSubmit,
    placeholder,
    error,
    isLoading,
}) => {
    const isButtonDisabled = isLoading || !discountCode
    return (
        <CheckoutFormCardSection
            className='checkout-form_discount-code'
            error={error}
        >
            <div className='rds-grid_2-columns_item rds-grid rds-grid_5-columns'>
                <FormItem
                    className='rds-grid_4-columns_item'
                    value={discountCode}
                    onChange={onChange}
                    placeholder={placeholder || 'Código de descuento'}
                />
                <Button
                    label={buttonLabel || 'Aplicar'}
                    onClick={onSubmit}
                    variant={ThemeVariants.WHITE}
                    disabled={isButtonDisabled}
                />
            </div>
        </CheckoutFormCardSection>
    )
}

export default CheckoutFormDiscountCode
